module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-cell-hover-right.802578d0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-cell-hover-right.png
// module id = 3824
// module chunks = 11